/**
 * Fetches the public configuration from the backend.
 * Returns { comingSoon: boolean }.
 * Never throws – falls back to { comingSoon: false } on error.
 */
export async function fetchPublicConfig() {
  try {
    const res = await fetch('/api/public/config');
    if (!res.ok) return { comingSoon: false, version: null };
    return await res.json();
  } catch {
    return { comingSoon: false, version: null };
  }
}
